<template>
	<v-container fluid pa-0>
	    <v-layout row wrap>
	        <v-flex xs12 pb-4>
				<general-types-crud
				    title="Tipo di Carta Fedeltà"
				    action-icon='settings'
				    model-def='generaltypes'
				    action-position='absolute'
                    :sub-filters="fidelitycardType"
				></general-types-crud>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
import GeneralTypesCrud from '@/components/GeneralTypesCrud'

export default {
	name: 'settings-other',
	components: {
		GeneralTypesCrud
	},

	data() {
		return {
			fidelitycardType: { key: 'fidelitycard_type' }
		}
	}
}
</script>
